import { useMsal } from '@azure/msal-react';
import React, { useEffect } from 'react';
import UserApi from '../../services/user';

const SyncProfile = () => {
  const { accounts } = useMsal();
  useEffect(() => {
    if (accounts.length) {
      const payload = {
        Id: accounts[0]?.localAccountId,
        Email: accounts[0]?.username,
        Name: accounts[0]?.name
      };
      UserApi.syncProfile(payload);
    }
  }, [accounts]);
  return <></>;
};

export default SyncProfile;
